import Dropzone from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Typography, Stack, Button } from '@mui/material';

export const FileUploadField = ({
  value,
  onChange,
  onError,
  maxSize = 10 * 1024 * 1024,
  accept = { 'image/*': ['.png', '.jpg', '.jpeg', '.pdf'] },
  label = "Click to upload or drag and drop"
}) => {
  return (
    <Dropzone
      onDrop={(acceptedFiles) => {
        onError(null);
        onChange(acceptedFiles[0] || null);
      }}
      maxFiles={1}
      maxSize={maxSize}
      accept={accept}
      onDropRejected={(rejections) => {
        const msg = rejections
          .map((r) => r.errors.map((e) => e.message).join(", "))
          .join("; ");
        onError(msg);
      }}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <section>
          <Box
            {...getRootProps()}
            sx={{
              border: '1px dashed',
              borderColor: isDragActive ? 'primary.light' : 'primary.main',
              borderRadius: 2,
              p: 4,
              textAlign: 'center',
              backgroundColor: isDragActive ? 'background.paper' : 'inherit',
              cursor: 'pointer'
            }}
          >
            <input {...getInputProps()} />

            {!value ? (
              <>
                <CloudUploadIcon fontSize="large" color="primary" />
                <Typography variant="body2" mt={1}>
                  {label}
                </Typography>
                <Typography variant="caption">
                  PNG, JPG, JPEG, PDF (max. {Math.round(maxSize / 1024 / 1024)}MB)
                </Typography>
              </>
            ) : (
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="body2">{value.name}</Typography>

                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onError(null);
                    onChange(null);
                  }}
                >
                  Remove File
                </Button>
              </Stack>
            )}
          </Box>
        </section>
      )}
    </Dropzone>
  );
};
